import React, { useState, useEffect } from "react";

export default function Chatbot() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [minimized, setMinimized] = useState(false);

  // Load chat history from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("chatbot_history");
    if (saved) setMessages(JSON.parse(saved));
  }, []);

  // Save chat history to localStorage
  useEffect(() => {
    localStorage.setItem("chatbot_history", JSON.stringify(messages));
  }, [messages]);

  // Send message to backend for RAG
  const sendMessage = async (msg) => {
    setMessages([...messages, { sender: "user", text: msg }]);
    setLoading(true);
    try {
      const res = await fetch("https://portfolio-kmbz.onrender.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: msg, history: messages }),
      });
      const data = await res.json();
      setMessages((prev) => [...prev, { sender: "bot", text: data.reply }]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, something went wrong." },
      ]);
    }
    setLoading(false);
  };

  return (
    <div
      className="
        fixed bottom-6 right-6 
        md:right-28    /* Push left on desktop so email is visible */
        z-50
      "
    >
      {/* Minimized Button */}
      {minimized ? (
        <button
          onClick={() => setMinimized(false)}
          className="px-4 py-2 bg-teal-300 text-slate-900 rounded shadow-lg hover:bg-teal-400 transition"
        >
          Chat
        </button>
      ) : (
        <div className="bg-slate-800 p-4 rounded-lg shadow-lg w-80">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div className="font-bold text-teal-300">
              Ask about Ashwin Sridharan
            </div>
            <button
              onClick={() => setMinimized(true)}
              className="text-slate-300 font-bold hover:text-teal-400 transition"
            >
              &#x2212; {/* minus sign */}
            </button>
          </div>

          {/* Chat Messages */}
          <div className="h-40 overflow-y-auto mb-2 bg-slate-900 p-2 rounded">
            {messages.map((m, i) => (
              <div
                key={i}
                className={`mb-1 text-sm ${
                  m.sender === "bot" ? "text-teal-300" : "text-slate-300"
                }`}
              >
                <b>{m.sender === "bot" ? "Lexa" : "You"}:</b> {m.text}
              </div>
            ))}
            {loading && (
              <div className="text-teal-300 text-sm">Lexa is typing...</div>
            )}
          </div>

          {/* Input */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (input.trim() && !loading) {
                sendMessage(input.trim());
                setInput("");
              }
            }}
            className="flex"
          >
            <input
              className="flex-1 px-2 py-1 rounded bg-slate-700 text-slate-200"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask about Ashwin..."
              disabled={loading}
            />
            <button
              className="ml-2 px-3 py-1 bg-teal-300 text-slate-900 rounded hover:bg-teal-400 transition"
              type="submit"
              disabled={loading}
            >
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
